import React from "react";
import T from "prop-types";

import Input from "../Input";

import styles from "./DurationStepperInput.module.scss";

const DurationStepperInput = ({ onStepDown, onStepUp, ...props }) => (
    <Input {...props} inputClassName={styles.inputWithStepper}>
        <div className={styles.stepperButtons}>
            <button
                aria-label="Tijd verhogen"
                className={styles.stepperButton}
                onClick={onStepUp}
                type="button"
            >
                <i className="fas fa-caret-up" />
            </button>
            <button
                aria-label="Tijd verlagen"
                className={styles.stepperButton}
                onClick={onStepDown}
                type="button"
            >
                <i className="fas fa-caret-down" />
            </button>
        </div>
    </Input>
);

DurationStepperInput.propTypes = {
    onStepDown: T.func.isRequired,
    onStepUp: T.func.isRequired
};

export default DurationStepperInput;
